import { Modal } from '@chikara/ui';
import { MetadataNameInput } from '@/features/card/components/CardDetailPage/MetadataNameInput';
import { t } from '@/i18n';
import styles from '../../pages/CardDetailPage/CardDetailPage.module.css';

interface EditAliasModalProps {
    isOpen: boolean;
    value: string;
    onClose: () => void;
    onChange: (value: string) => void;
    onSave: () => void;
}

export const EditAliasModal = ({
    isOpen,
    value,
    onClose,
    onChange,
    onSave,
}: EditAliasModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('dashboard.card.detail.modals.editAlias.title')}
            description={
                <div className={styles.editAliasContent}>
                    <p className={styles.editAliasDescription}>
                        {t('dashboard.card.detail.modals.editAlias.description')}
                    </p>
                    <MetadataNameInput
                        label={t('dashboard.card.detail.modals.editAlias.label')}
                        value={value}
                        onChange={onChange}
                        autoFocus
                    />
                </div>
            }
            actionLabel={t('dashboard.card.detail.modals.editAlias.save')}
            onAction={onSave}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            showCloseButton={true}
            isActionDisabled={!value}
        />
    );
};
